import type { ReactNode } from 'react';

interface MarqueeProps {
  items: ReactNode[];
  /** Seconds for one full pass. */
  duration?: number;
  className?: string;
}

/**
 * A continuous ticker.
 *
 * The track is duplicated so the loop is seamless; the copy is aria-hidden so
 * the phrases are announced once. Pauses on hover.
 *
 * It carries statements, never quotes: the product's rule is that no number
 * appears without a named source behind it, and a decorative price would break
 * that on the most visible surface of the site.
 */
export function Marquee({ items, duration = 42, className }: MarqueeProps) {
  const track = (
    <div className="marquee__track">
      {items.map((item, i) => (
        <span key={i} className="marquee__item">
          {item}
        </span>
      ))}
    </div>
  );

  return (
    <div
      className={`marquee ${className ?? ''}`}
      style={{ ['--marquee-duration' as string]: `${duration}s` }}
    >
      {track}
      <div className="marquee__track" aria-hidden="true">
        {items.map((item, i) => (
          <span key={i} className="marquee__item">
            {item}
          </span>
        ))}
      </div>
    </div>
  );
}
